import { Divider } from '@mui/material';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { useRegion } from 'common/hooks/region';
import { Page } from 'components/Page';
import { PageHeader } from 'layouts/Generic/page-header';
import * as React from 'react';
import { PortCollectionFeature } from 'types/Port';
import { ByTerminal } from './ByTerminal';
import { ModeSelector } from './ModeSelector';
import { TERMINAL_SCREENSHOTS_PARAMS } from './params';
import { TerminalScreenshotsPage } from './TerminalScreenshotsPage';

/**
 * Root level page for the Terminal Screenshots feature.
 */
export const TerminalScreenshots: React.FC = () => {
  const region = useRegion();
  const { searchParams } = useCustomSearchParams(TERMINAL_SCREENSHOTS_PARAMS);
  const legacy = region.features?.includes(PortCollectionFeature.LegacyTerminalScreenshots);

  let inner = <ByTerminal />;

  if (legacy) {
    switch (searchParams.mode) {
      case 'terminal':
        inner = <ByTerminal />;
        break;
      case 'specific-date':
      case 'date-range':
      default:
        inner = (
          <div className="px-8">
            <TerminalScreenshotsPage />
          </div>
        );
        break;
    }
  }

  return (
    <Page className="space-y-4">
      <div className="px-16 pt-8 space-y-8">
        <PageHeader title="Retrieve past terminal instruction screenshots" />
        <Divider />
        {legacy ? <ModeSelector /> : null}
      </div>
      {inner}
    </Page>
  );
};
TerminalScreenshots.displayName = 'TerminalScreenshots';
